import { html } from 'uhtml';
import ToggleMenu from '../../00-basics/expandy/expandy.wsutogglemenu';

function MenuBlockToggleButton(baseId, fallbackText) {
  return html.node`
    <span id="${`${baseId}-toggle`}" class="menu__toggle button--toggle button--menu">
      <span class="collapsed-only">
        <span class="visually-hidden">Open </span>menu
      </span>
      <span class="expanded-only">
        Close<span class="visually-hidden"> menu</span>
      </span>
      <span class="visually-hidden">: ${fallbackText}</span>
      <i class="fas fa-caret-down collapsed-only"></i>
      <i class="fas fa-caret-down expanded-only"></i>
    </span>
  `;
}

function CollapsibleMenuBlock(block) {
  const blockTitle = block.querySelector(':scope > .block__title');
  blockTitle.addEventListener('click', (evt) => {
    if (evt.target.classList.contains('block__title')) {
      blockTitle.querySelector(':scope > button').click();
    }
  });

  const toggleButton = MenuBlockToggleButton(block.id, blockTitle.textContent);
  blockTitle.appendChild(toggleButton);

  block.querySelectorAll(':scope > .menu').forEach((menu) => {
    const hasActiveChildren = block.querySelector(
      'li.leaf:not(.home) > .active',
    );

    menu.dataset.menustate = hasActiveChildren ? 'closed' : 'open';
    menu.setAttribute('aria-labelledby', toggleButton.id);
    menu.setAttribute('id', `${block.id}-menu`);

    ToggleMenu(menu, {
      closeOnOutsideClick: false,
      closeOnEscape: false,
    });
  });
}

export default CollapsibleMenuBlock;
